module.exports = __webpack_public_path__ + "img/12.632a4ed.png";